import React from "react";
import {Translation as T} from "@awe-web/shared/lib";
import {TypeArea} from "../../../components/layout.js";
import {ScreenSection, ScreenHeading} from "../../../components/screen.js";

import History from "../../../history/components/history";

const HEADING = "ALG0000165";

export default function B2B_History() {
  return (
    <ScreenSection main dark>
      <TypeArea>
        <ScreenHeading><T code={HEADING} /></ScreenHeading>
        <History />
      </TypeArea>
    </ScreenSection>
  );
}
